module.exports = __webpack_public_path__ + "static/media/methodanimation3.022ec514.gif";